import IconType from "@/types/Icon.type";
import IconPetsGroupNotAvailable from "@Icons/ticket/amenities/pets/IconPetsGroupNotAvailable";
import IconMealsGroupNotAvailable from "@Icons/ticket/amenities/meals/IconMealsGroupNotAvailable";

function IconTicketAmenityGroupNotAvailable(props: IconType) {
    const {title} = props

    const matchedAmenityGroups = {
        IconPetsGroupNotAvailable,
        IconMealsGroupNotAvailable,
    }

    const AmenityGroupIcon = matchedAmenityGroups[title]

    if (AmenityGroupIcon) {
        return <AmenityGroupIcon {...props}/>
    }

    return null
}

export default IconTicketAmenityGroupNotAvailable